import { createContext } from 'react';
import type { User } from '../domain/models';

export interface AuthValue {
  user: User | null;
  loading: boolean;
  login(email: string, password: string): Promise<void>;
  register(name: string, email: string, password: string): Promise<void>;
  loginWithGoogle(code: string, password?: string): Promise<void>;
  logout(): void;
}

export const AuthContext = createContext<AuthValue | null>(null);
